var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleticon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_4722_8956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.2497 50.4163H13.7497V18.333H9.16634V49.7288C9.16634 52.2497 11.2288 54.9997 13.7497 54.9997H41.2497C43.7705 54.9997 45.833 52.2497 45.833 49.7288V18.333H41.2497V50.4163ZM34.3747 9.16634V4.58301H20.6247V9.16634H4.58301V13.7497H50.4163V9.16634H34.3747ZM20.6247 22.9163V45.833H25.208V22.9163H20.6247ZM29.7913 22.9163V45.833H34.3747V22.9163H29.7913Z",
    fill: "#FF2B2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4722_8956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleticon);
export default __webpack_public_path__ + "static/media/deleticon.38623bde1c2dad176fd1a5dceceb7671.svg";
export { ForwardRef as ReactComponent };